"use client";

import React from "react";
import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const tiers = [{
  id: 1,
  title: "Knippen & Styling",
  price: "€ 45",
  description: "Een frisse look die perfect aansluit bij uw gezichtsvorm.",
  buttonText: "Maak afspraak",
  isPopular: false
}, {
  id: 2,
  title: "Kleur & Balayage",
  price: "€ 95",
  description: "Onze specialiteit: natuurlijke overgangen en diepe glans.",
  buttonText: "Plan uw kleur",
  isPopular: true
}, {
  id: 3,
  title: "Luxe Treatments",
  price: "€ 35",
  description: "Herstel en verzorging voor gezond, stralend haar.",
  buttonText: "Gratis advies",
  isPopular: false
}];
const features = [{
  tierId: 1,
  text: "Wassen, knippen & föhnen"
}, {
  tierId: 1,
  text: "Ontspannende hoofdmassage"
}, {
  tierId: 1,
  text: "Persoonlijk stylingadvies"
}, {
  tierId: 2,
  text: "Balayage of highlights techniek"
}, {
  tierId: 2,
  text: "Kleuradvies op maat"
}, {
  tierId: 2,
  text: "Inclusief toner & verzorging"
}, {
  tierId: 2,
  text: "Olaplex herstelbehandeling"
}, {
  tierId: 2,
  text: "Professionele finish & styling"
}, {
  tierId: 3,
  text: "Diepvoedend haarmasker"
}, {
  tierId: 3,
  text: "Keratine boost behandeling"
}, {
  tierId: 3,
  text: "Scalp therapy massage"
}, {
  tierId: 3,
  text: "Vrijblijvend productadvies"
}];
export default function FixedRates() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="82686" id="tarieven-behandelingen" className="bg-background py-24 px-4 md:px-8 overflow-hidden">
      <div ref={ref} className={cn("max-w-7xl mx-auto transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-4 font-serif tracking-tight">
            Tarieven & Behandelingen
          </h2>
          <p className="text-lg text-muted-foreground font-sans">
            Luxe haarverzorging met oog voor detail en vakmanschap. 
            Heldere tarieven voor een resultaat dat bij u past.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
          {tiers.map((tier, index) => {
          const tierFeatures = features.filter(f => f.tierId === tier.id);
          return <div key={tier.id} data-index={index} className={cn("relative transition-all duration-300", tier.isPopular ? "md:scale-105 z-10" : "z-0")}>
                <Card className={cn("h-full flex flex-col rounded-xl", tier.isPopular ? "border-2 border-primary shadow-xl" : "border border-border shadow-sm")}>
                  {tier.isPopular && <div className="absolute -top-4 left-0 right-0 flex justify-center">
                      <Badge className="bg-primary text-primary-foreground px-4 py-1 text-sm uppercase tracking-widest font-semibold shadow-md">
                        Meest gekozen
                      </Badge>
                    </div>}

                  <CardHeader className={cn("text-center pb-2", tier.isPopular ? "pt-8" : "")}>
                    <CardTitle className="text-2xl font-bold text-foreground font-serif">
                      {tier.title}
                    </CardTitle>
                    <CardDescription className="mt-2 h-10 font-sans">
                      {tier.description}
                    </CardDescription>
                  </CardHeader>

                  <CardContent className="flex-grow flex flex-col items-center pt-4">
                    <div className="mb-8 text-center">
                      <span className="text-4xl md:text-5xl font-bold text-secondary tracking-tighter font-serif">
                        {tier.price}
                      </span>
                      <span className="text-muted-foreground ml-1 text-sm font-medium font-sans">
                        vanaf
                      </span>
                    </div>

                    <ul className="w-full space-y-4">
                      {tierFeatures.map((feature, fIndex) => <li key={fIndex} data-index={fIndex} className="flex items-start gap-3 text-sm text-foreground font-sans border-b border-border/50 pb-2 last:border-0">
                          <Check className="size-5 text-primary shrink-0 mt-0.5" />
                          <span>{feature.text}</span>
                        </li>)}
                    </ul>
                  </CardContent>

                  <CardFooter className="pt-6">
                    <Button asChild variant={tier.isPopular ? "default" : "outline"} className={cn("w-full rounded-lg h-12 text-base font-medium uppercase tracking-widest transition-colors duration-400", tier.isPopular ? "bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg" : "border-primary text-primary hover:bg-accent")}>
                      <Link to="#">{tier.buttonText}</Link>
                    </Button>
                  </CardFooter>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}